
import { memo } from 'react';
import { NodeProps, NodeResizer } from '@xyflow/react';

interface TextNodeProps extends NodeProps {
  data: {
    text?: string;
    uuid: string;
    textAlign?: 'left' | 'center' | 'right';
  };
  selected: boolean;
}

const TextNode = memo(({ data, selected }: TextNodeProps) => {
  const getTextAlignment = () => {
    switch (data.textAlign) {
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
      default:
        return 'text-left';
    }
  };

  return (
    <>
      <NodeResizer minWidth={100} minHeight={30} />
      <div 
        className={`bg-transparent p-2 min-w-[100px] min-h-[30px] flex items-center justify-center rounded ${
          selected ? 'border-2 border-primary' : 'border-none'
        }`}
        style={{ width: '100%', height: '100%' }}
      >
        <div className={`text-sm text-gray-700 whitespace-pre-wrap break-words w-full ${getTextAlignment()}`}>
          {data.text || 'Texto'}
        </div>
      </div>
    </>
  );
});

TextNode.displayName = 'TextNode';

export { TextNode };
